import { IAppState } from '../../../../../AppModulesWrapper';
import { createSelector } from 'reselect';
import { selectActivePackage } from './selectActivePackage';

export const selectIsPackageSelected = createSelector(
  (state: IAppState) => selectActivePackage(state),
  selectedPackage => Boolean(selectedPackage),
);
